import autobg from 'autobg.macro';

const info = {
  master: [
    {
      title: '万事达卡世界借记卡',
      desc: '享万事达卡世界卡级别高端权益',
      img: autobg('assets/img/list/master_shijie.png'),
      trackName: '万事达列表页_世界借记卡'
    },
    {
      title: '万事达卡金卡借记卡',
      desc: '全球众多酒店预定折扣、餐厅用餐折扣、租车礼遇等',
      img: autobg('assets/img/list/master_jinka.png'),
      trackName: '万事达列表页_万事达金卡'
    },
    {
      title: '万事达卡白金借记卡',
      desc: '全球众多酒店预定折扣、餐厅用餐折扣、租车礼遇等',
      img: autobg('assets/img/list/master_baijinka.png'),
      trackName: '万事达列表页_万事达白金卡'
    },
    {
      title: '万事达卡非人哉借记卡',
      desc: '结合经典二次元IP《非人哉》，双卡面选择',
      img: autobg('assets/img/list/master_feirenzai.png'),
      trackName: '万事达列表页_万事达非人哉卡'
    }
  ],
  visa: [
    {
      title: 'Visa白金借记卡',
      desc: '留学服务立减高达2000元',
      img: autobg('assets/img/list/visa_baijin.png'),
      trackName: 'VISA列表页_VISA白金卡'
    },
    {
      title: 'Visa金卡借记卡',
      desc: '30万留学生专属保障计划优惠购',
      img: autobg('assets/img/list/visa_jinka.png'),
      trackName: 'VISA列表页_VISA金卡'
    },
    {
      title: 'Visa冬奥借记卡(黑卡)',
      desc: '全球知名雪场低至7折优惠',
      img: autobg('assets/img/list/visa_heika.png'),
      trackName: 'VISA列表页_VISA冬奥黑卡'
    },
    {
      title: 'Visa冬奥借记卡(蓝卡)',
      desc: '全球知名雪场低至7折优惠',
      img: autobg('assets/img/list/visa_lanka.png'),
      trackName: 'VISA列表页_VISA冬奥蓝卡'
    }
  ]
};

export default info;
